import styles from './AboutUs.module.css';

const InfoCard = () => {
    return ( 
        <div className={` ${styles.infocard} ${styles.card}`}></div>
     );
}
 
export default InfoCard;